import { gql } from '@apollo/client';

export const OPS_TOOL_SETTLEMENT_CLIENTS_BY_SCENARIO = gql`
  query OpsToolSettlementClientsByScenario($businessScenarioCode: Long!) {
    opsToolSettlementClientsByScenario(businessScenarioCode: $businessScenarioCode) {
      value
      label
    }
  }
`;

export const OPS_TOOL_BILLING_PERIOD_INSTANCES = gql`
  query OpsToolBillingPeriodInstances(
    $filters: OpsSettlementBillFilterInput!
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolBillingPeriodInstances(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        id
        ruleId
        settlementClientId
        settlementClientName
        billType
        version
        periodStart
        periodEnd
        closeTime
        issueTime
        status
        isIssued
        feeItemIdsJson
        feeItems {
          id
          code
          name
        }
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_SETTLEMENT_FEE_ITEMS = gql`
  query OpsToolSettlementFeeItems($businessScenarioCode: Long!) {
    opsToolSettlementFeeItems(businessScenarioCode: $businessScenarioCode) {
      id
      businessScenarioCode
      name
      nameEn
      code
      amountSign
      allowAdjustment
    }
  }
`;

export const OPS_TOOL_UPDATE_BILLING_PERIOD_FEE_ITEMS = gql`
  mutation OpsToolUpdateBillingPeriodFeeItems($input: OpsUpdateBillingPeriodFeeItemsInput!) {
    opsToolUpdateBillingPeriodFeeItems(input: $input) {
      success
      code
      message
      updatedCount
    }
  }
`;

export const OPS_TOOL_SETTLEMENT_BILLS = gql`
  query OpsToolSettlementBills(
    $filters: OpsSettlementBillFilterInput!
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolSettlementBills(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        id
        settlementClientId
        settlementClientName
        billingPeriodInstanceId
        billType
        currency
        totalAmount
        totalAmountExclTax
        periodStart
        periodEnd
        status
        isCanceled
        feeSummaries {
          id
          settlementFeeItemId
          feeItemName
          feeItemCode
          amount
        }
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_ADD_BILL_FEE_SUMMARIES = gql`
  mutation OpsToolAddBillFeeSummaries($input: OpsAddBillFeeSummaryInput!) {
    opsToolAddBillFeeSummaries(input: $input) {
      success
      code
      message
      createdCount
      skippedCount
    }
  }
`;

export const OPS_TOOL_SETTLEMENT_OPERATION_LOGS = gql`
  query OpsToolSettlementOperationLogs(
    $filters: OpsSettlementOperationLogFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolSettlementOperationLogs(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        id
        operatorId
        operatorName
        operatedAt
        functionType
        changeType
        businessScenarioCode
        settlementClientId
        operationMode
        operationStatus
        affectedCount
        skippedCount
        errorMessage
        operationDetail
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_SETTLEMENT_AUDIT_LOGS = gql`
  query OpsToolSettlementAuditLogs(
    $filters: OpsSettlementAuditLogFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolSettlementAuditLogs(filters: $filters, pageRequest: $pageRequest) {
      success
      code
      message
      content {
        id
        operatorId
        operatorName
        module
        moduleName
        operationType
        operationTypeName
        businessId
        detailJson
        operatedAt
      }
      totalElements
      page
      size
    }
  }
`;

export const OPS_TOOL_TMP_RUN_TASK_SUMMARY = gql`
  query OpsToolTmpRunTaskSummary {
    opsToolTmpRunTaskSummary {
      activeCount
      minActiveId
      maxActiveId
    }
  }
`;

export const OPS_TOOL_CLEAR_TMP_RUN_TASK = gql`
  mutation OpsToolClearTmpRunTask {
    opsToolClearTmpRunTask {
      success
      code
      message
      affectedCount
      operationDetail
    }
  }
`;

export const OPS_TOOL_INSERT_TMP_RUN_TASK = gql`
  mutation OpsToolInsertTmpRunTask($input: OpsTmpRunTaskInsertInput!) {
    opsToolInsertTmpRunTask(input: $input) {
      success
      code
      message
      affectedCount
      skippedCount
      beginTaskId
      endTaskId
      operationDetail
    }
  }
`;

export const OPS_TOOL_RERUN_NEW_ZONE_BY_TMP_RUN_TASK = gql`
  mutation OpsToolRerunNewZoneByTmpRunTask($input: OpsTmpRunTaskRangeInput!) {
    opsToolRerunNewZoneByTmpRunTask(input: $input) {
      success
      code
      message
      affectedCount
      beginTaskId
      endTaskId
      operationDetail
    }
  }
`;

export const OPS_TOOL_RERUN_PRICING_BY_TMP_RUN_TASK = gql`
  mutation OpsToolRerunPricingByTmpRunTask($input: OpsTmpRunTaskPricingRerunInput!) {
    opsToolRerunPricingByTmpRunTask(input: $input) {
      success
      code
      message
      taskId
      beginTaskId
      endTaskId
      operationDetail
    }
  }
`;

export const OPS_TOOL_RERUN_PRESORT_FEE_BY_TMP_RUN_TASK = gql`
  mutation OpsToolRerunPresortFeeByTmpRunTask($input: OpsTmpRunTaskRangeInput!) {
    opsToolRerunPresortFeeByTmpRunTask(input: $input) {
      success
      code
      message
      taskId
      beginTaskId
      endTaskId
      operationDetail
    }
  }
`;

export const OPS_TOOL_RERUN_TT_SORTING_PICKUP_UNLOADING_FEE_BY_TMP_RUN_TASK = gql`
  mutation OpsToolRerunTtSortingPickupUnloadingFeeByTmpRunTask($input: OpsTmpRunTaskRangeInput!) {
    opsToolRerunTtSortingPickupUnloadingFeeByTmpRunTask(input: $input) {
      success
      code
      message
      taskId
      beginTaskId
      endTaskId
      operationDetail
    }
  }
`;

export const OPS_TOOL_RESET_TMP_RUN_TASK_CONFIG_FOR_CLEARING = gql`
  mutation OpsToolResetTmpRunTaskConfigForClearing {
    opsToolResetTmpRunTaskConfigForClearing {
      success
      code
      message
      operationDetail
    }
  }
`;

export const OPS_TOOL_EXECUTE_SETTLEMENT_OPS = gql`
  mutation OpsToolExecuteSettlementOps($input: OpsExecuteSettlementOpsInput!) {
    opsToolExecuteSettlementOps(input: $input) {
      success
      code
      message
    }
  }
`;

export const OPS_TOOL_RERUN_VOUCHER_CLEARING_BY_TMP_RUN_TASK = gql`
  mutation OpsToolRerunVoucherClearingByTmpRunTask($input: OpsTmpRunTaskClearingRerunInput!) {
    opsToolRerunVoucherClearingByTmpRunTask(input: $input) {
      success
      code
      message
      taskId
      operationDetail
    }
  }
`;

// ------------------------------------------------------------ 大表拆分补偿

export const OPS_TOOL_BIG_TABLE_MIGRATE_CLEARING = gql`
  mutation OpsToolBigTableMigrateClearing($businessIds: [String!]!) {
    opsToolBigTableMigrateClearing(businessIds: $businessIds) {
      success
      code
      message
      items {
        businessId
        mainCount
        logCount
        status
        message
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_MIGRATE_PRICING = gql`
  mutation OpsToolBigTableMigratePricing($businessIds: [String!]!) {
    opsToolBigTableMigratePricing(businessIds: $businessIds) {
      success
      code
      message
      items {
        businessId
        mainCount
        logCount
        status
        message
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_MIGRATE_BILL_CLEARING_MAP = gql`
  mutation OpsToolBigTableMigrateBillClearingMap($billIds: [Long!]!) {
    opsToolBigTableMigrateBillClearingMap(billIds: $billIds) {
      success
      code
      message
      items {
        billId
        mapCount
        status
        message
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_QUERY_CLEARING = gql`
  query OpsToolBigTableQueryClearing($businessIds: [String!]!) {
    opsToolBigTableQueryClearing(businessIds: $businessIds) {
      success
      code
      message
      items {
        id
        businessId
        otherBusinessId
        settlementClientId
        settlementItemCode
        settlementItemName
        amount
        amountHm
        status
        pricingId
        businessTime
        settlementTime
        clearingNode
        isDeleted
        reRunTaskId
        createdAt
        updatedAt
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_QUERY_CLEARING_LOG = gql`
  query OpsToolBigTableQueryClearingLog($businessIds: [String!]!) {
    opsToolBigTableQueryClearingLog(businessIds: $businessIds) {
      success
      code
      message
      items {
        id
        businessId
        clearingId
        pricingId
        logEvent
        reRunTaskId
        operatorId
        description
        createdAt
        updatedAt
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_QUERY_PRICING = gql`
  query OpsToolBigTableQueryPricing($businessIds: [String!]!) {
    opsToolBigTableQueryPricing(businessIds: $businessIds) {
      success
      code
      message
      items {
        id
        businessId
        otherBusinessId
        businessCode
        businessScenarioCode
        businessFeeCode
        amount
        clientId
        pricingAt
        businessAt
        pricingNode
        pricingVersion
        pricingErrorCode
        isSuccess
        isDeleted
        rePushTaskId
        submitter
        createdAt
        updatedAt
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_QUERY_PRICING_LOG = gql`
  query OpsToolBigTableQueryPricingLog($businessIds: [String!]!) {
    opsToolBigTableQueryPricingLog(businessIds: $businessIds) {
      success
      code
      message
      items {
        id
        pricingResultId
        businessId
        logEvent
        rePushTask
        operator
        pricingVersion
        createdAt
        updatedAt
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_QUERY_BILL_CLEARING_MAP = gql`
  query OpsToolBigTableQueryBillClearingMap($billIds: [Long!]!) {
    opsToolBigTableQueryBillClearingMap(billIds: $billIds) {
      success
      code
      message
      items {
        id
        billId
        clearingId
        businessId
        settlementFeeItem
        amount
        amountHm
        isDeleted
        createdAt
        updatedAt
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_CALC_CLEARING_LOCATION = gql`
  query OpsToolBigTableCalcClearingLocation($businessIds: [String!]!) {
    opsToolBigTableCalcClearingLocation(businessIds: $businessIds) {
      success
      code
      message
      items {
        businessId
        indexBucket
        indexTable
        monthSuffixes
        monthTables
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_CALC_PRICING_LOCATION = gql`
  query OpsToolBigTableCalcPricingLocation($businessIds: [String!]!) {
    opsToolBigTableCalcPricingLocation(businessIds: $businessIds) {
      success
      code
      message
      items {
        businessId
        indexBucket
        indexTable
        monthSuffixes
        monthTables
      }
    }
  }
`;

export const OPS_TOOL_BIG_TABLE_CALC_BILL_LOCATION = gql`
  query OpsToolBigTableCalcBillLocation($billIds: [Long!]!) {
    opsToolBigTableCalcBillLocation(billIds: $billIds) {
      success
      code
      message
      items {
        billId
        indexBucket
        indexTable
        monthSuffix
        mapTable
        reason
      }
    }
  }
`;
